var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucursalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SucursalIcon_svg__clip0_451_6010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12.532c.41.305.96.453 1.5.453.55 0 1.09-.148 1.5-.453.62-.485 1-1.232 1-2.107 0 .875.37 1.622 1 2.107.41.305.96.453 1.5.453.55 0 1.09-.148 1.5-.453.62-.485 1-1.232 1-2.107 0 .875.37 1.622 1 2.107.41.305.96.453 1.51.453.54 0 1.08-.148 1.49-.453.62-.485 1-1.232 1-2.107 0 .875.37 1.622 1 2.107.41.305.96.453 1.5.453.55 0 1.09-.148 1.5-.453.63-.485 1-1.232 1-2.107V9.372L19 2H6L2 9.372v1.053c0 .875.37 1.622 1 2.107zM5 22h5v-5.266h4V22h5v-7.372a2.143 2.143 0 01-1-.453c-.63-.474-1-.769-1-1.643 0 .874-.38 1.169-1 1.643-.41.316-.95.453-1.49.463-.55 0-1.1-.147-1.51-.463-.63-.474-1-.769-1-1.643 0 .874-.38 1.169-1 1.643-.41.316-.95.453-1.5.463-.54 0-1.09-.147-1.5-.463-.63-.474-1-.769-1-1.654 0 .885-.38 1.18-1 1.654-.29.221-.63.4-1 .463V22z",
    fill: "#0A111E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SucursalIcon_svg__clip0_451_6010"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgSucursalIcon;